exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tz-dropdown-menu{max-height:300px;overflow-y:auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/panels/panel/scheduler.component/styles.less
 ** module id = 620
 ** module chunks = 0
 **/